module.exports = __webpack_public_path__ + "img/16_26@3x.0b3abe43.png";